
import { defineComponent, onMounted, computed, ref } from "vue";
import {
  LayoutFooter,
  NewsCard,
  Section as CommonSection,
  SectionColors,
} from "@/components";
import { useI18n } from "vue-i18n";
import { useStore, ActionTypes, AdvertisementSpots } from "@/store";
import {VIASAT_AD_ENDPOINT} from "@/services/advertisements";

export default defineComponent({
  setup() {
    const { t } = useI18n({
      inheritLocale: true,
      useScope: "global",
    });

    const store = useStore();

    const trendingNews = computed(() => store.getters.trendingNews);
    const latestNews = computed(() => store.getters.latestNews);
    const moreNews = computed(() => store.getters.moreNews);

    const pageReady = ref(false);

    onMounted(async () => {
          await store.dispatch(ActionTypes.GetViasatFlightData);

          if (store.getters.viasatFlightData != undefined) {
            const script = document.createElement('script');
            script.type = 'module';
            script.innerHTML = `
                    import AdUnit from '${VIASAT_AD_ENDPOINT}interstitial/v1/index.js';
                    AdUnit({
                        containerId: "ad-unit-news",
                        count: 3,
                        destination: "${store.getters.viasatFlightData?.destination}",
                        flightId: "${store.getters.viasatFlightData?.flightId}",
                        flightNumber: "${store.getters.viasatFlightData?.flightNumber}",
                        locale: "en-US",
                        origin: "${store.getters.viasatFlightData?.origin}",
                        placementTag: "interstitial_1",
                        vehicleId: "${store.getters.viasatFlightData?.vehicleId}",
                        venue: "VIA",
                        timeout: 5000,
                        identifiers: {
                            DEVICE_ID: "TestIfcDeviceGuidOk",
                        },
                    });
                  `;
            document.body.appendChild(script);
          }

          Promise.all([
            store.dispatch(ActionTypes.GetTrendingNews),
            store.dispatch(ActionTypes.GetLatestNews),
            store.dispatch(ActionTypes.GetMoreNews),
          ]).then(() => (pageReady.value = true))
        }
    );

    return {
      t,
      trendingNews,
      latestNews,
      moreNews,
      pageReady,
    };
  },
  data() {
    return {
      adSpotTop: AdvertisementSpots.NewsTop,
      adSpotFooter: AdvertisementSpots.NewsFooter,
      mainColor: SectionColors.NewsMainColor,
      secondaryColor: SectionColors.NewsSecondaryColor,
    };
  },
  computed: {
    cssProps(): unknown {
      return {
        "--news-main-color": this.$data.mainColor,
        "--news-secondary-color": this.$data.secondaryColor,
      };
    },
  },
  components: {
    LayoutFooter,
    CommonSection,
    NewsCard,
  },
});
